import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import RoleList from '../../components/Entity/Roles/List/List';
 
const RolesPage = () => {
  return <Layout nonav={0} fullwidth={0}>
       <RoleList></RoleList>
   
  </Layout>;
}

export default RolesPage;